<template>
	<input :id="context.id" ref="checkbox" type="checkbox" @click.prevent="toggle" :checked="checkedState === true"/>
</template>

<script src="./FormulateTriCheckbox.js"></script>
